import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import ProductionPlan from "@/pages/ProductionPlan";
import Recipes from "@/pages/Recipes";
import PurchaseOrders from "@/pages/PurchaseOrders";
import Receipts from "@/pages/Receipts";
import Materials from "@/pages/Materials";
import Consumption from "@/pages/Consumption";
import DetailedStock from "@/pages/DetailedStock";
import Schedule from "@/pages/Schedule";
import Activity from "@/pages/Activity";
import AdminPanel from "@/pages/AdminPanel";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0F17] text-[#94A3B8]">
        Yükleniyor...
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="uretim-plani" element={<ProductionPlan />} />
              <Route path="uretim-cizelgesi" element={<Schedule />} />
              <Route path="receteler" element={<Recipes />} />
              <Route path="satin-alma" element={<PurchaseOrders />} />
              <Route path="gelen-malzemeler" element={<Receipts />} />
              <Route path="malzemeler" element={<Materials />} />
              <Route path="tuketimler" element={<Consumption />} />
              <Route path="detayli-stok" element={<DetailedStock />} />
              <Route path="gecmis" element={<Activity />} />
              <Route path="yonetici" element={<AdminPanel />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
